export default __webpack_public_path__ + "static/NuvemFiscalNFCom-e044ff01b20ab24278e625dcbc72efd5.png";